export enum AppRoles {
  GlobalAdmin = "GlobalAdmin",
  PartnerAdmin = "PartnerAdmin",
  Accountant = "Accountant",
  Demo = "Demo",
}
